export default {
    operatorRepositoryName: 'OperatorRepository',
};